// extracted by mini-css-extract-plugin
export default {"tcoButton":"_3p5CGi","tcoButtonDisabled":"_21jFlD"};